export enum InventoryType {
  now = 1,
  future = 2,
  all = 3,
}

export interface Inventory {
  productId: string;
  brandId: string;
  inventoryId: string;
  inventoryType: InventoryType;
  availabilityDateFrom: string;
  availabilityDateTo?: string;
  validityDateFrom?: string;
  validityDateTo?: string;
  priceValidityDate?: string;
  quantity?: number;
  isEnabled: boolean;
  isConsignment: boolean;
  isCurrent: boolean;
}

export interface ProductInventories {
  brandId: string;
  productId: string;
  inventories: Inventory[];
}
